import store from "@dbox/cromie-common/store";
import { getAccessToken } from "@dbox/cromie-common/store/reducers/app.reducer";
import { logOut } from "@dbox/core/actions/cromie/auth";
import { createHttpClient, localStorage } from "@dbox/core";

export default createHttpClient({
  storage: localStorage,
  getToken: () => getAccessToken(store.getState()),
  baseURL: process.env.REACT_APP_API_URL,
  logOut: () => store.dispatch(logOut()),
});
